export default __webpack_public_path__ + "static/media/Parent_Parties_Logo.17e40320.png";